const DEFAULT_API_BASE_URL = "http://localhost:5000";

function trimTrailingSlash(value) {
  return value.replace(/\/+$/, "");
}

function readRuntimeConfig() {
  if (typeof window === "undefined" || !window.__APP_CONFIG__) {
    return {};
  }

  return window.__APP_CONFIG__;
}

const runtimeConfig = readRuntimeConfig();

const resolvedApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  runtimeConfig.apiBaseUrl ||
  DEFAULT_API_BASE_URL;

const resolvedSocketBaseUrl =
  process.env.REACT_APP_SOCKET_BASE_URL ||
  runtimeConfig.socketBaseUrl ||
  resolvedApiBaseUrl;

export const base_url = trimTrailingSlash(resolvedApiBaseUrl);
export const socket_base_url = trimTrailingSlash(resolvedSocketBaseUrl);
export const base = socket_base_url.replace(/^https?:\/\//, "") + "/";
